<script>
  import { domainName, record, lookupFound } from '../stores.js';
  import SPFResultRaw from './spfResultRaw.svelte';
  import ContactUsForm from '../ContactUsForm.svelte';
  import SPFResultNotFound from './spfResultNotFound.svelte';
  import SPFResultSummary from './spfResultSummary.svelte';
  import SPFResultTags from './spfResultTags.svelte';
  // import SPFShare from './spfShare.svelte';
  ///import Sidebar from '../Sidebar.svelte';

  let modifySpf = false;

  // Function to refresh the page
  function refreshPage(event) {
    event.preventDefault(); // Prevents the default anchor behavior
    location.reload(); // Reloads the page
  }
</script>

<section class="tool-banner tool-banner-spf mb-5">
  <div class="banner"></div>
  <div class="row-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12 m-auto banner-text">
          <h2>View SPF Record</h2>
          <p>See which servers are authorized to send email for a domain.</p>
          <button on:click={() => window.location.reload()} class ="refresh-page"  title="Look Up or Generate SPF Record">Search New Domain</button><i class="fa-solid fa-arrows-rotate"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 m-auto">
          <div class="result-box">
            <div class="found">
              {#if $lookupFound}
                <ul class="result-heading record-found">
                  <li><h3>SPF Record Found: {$domainName}</h3></li>
                </ul>
              {:else}
                <ul class="result-heading no-record-found">
                  <li><h3>SPF Record Not Found: {$domainName}</h3></li>
                </ul>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="record record-spf">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        {#if $lookupFound}
          <SPFResultRaw />
          <SPFResultSummary />
          <SPFResultTags />

          <div class="btn-wrap">
            <button on:click|preventDefault={() => modifySpf = true} disabled={modifySpf} class="btn btn-1 btn-lg" id="modify-spf">Modify SPF Record</button>
            <!-- <a href="/resources/dmarc" class="btn btn-1 btn-lg" title="Look Up or Generate DMARC Record">Create DMARC Record</a> -->
          </div>

          {#if modifySpf}
            <div class="record-box spf-modify-form">
              <div id="headingRaw" class="box-label">
                <h5>Modify SPF Record</h5>
                <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseModify" aria-expanded="true" aria-controls="collapseModify" aria-label="Close"></button>
              </div>
              <div id="collapseModify" class="box-detail" aria-labelledby="headingRaw">
                <ContactUsForm />
              </div>
            </div>
          {/if}
        {:else}
          <SPFResultNotFound />
        {/if}
      </div>


    </div>
  </div>
</section>

<style>

</style>
